import masterServicesActionTypes from './action-types';

export const fetchMasterServicesList = payload => ({
  type: masterServicesActionTypes.FETCH_MASTERSERVICES_LIST,
  payload,
});

export const fetchMasterServicesListSuccess = payload => ({
  type: masterServicesActionTypes.FETCH_MASTERSERVICES_LIST_SUCCESS,
  payload,
});

export const fetchMasterServicesListFail = payload => ({
  type: masterServicesActionTypes.FETCH_MASTERSERVICES_LIST_FAIL,
  payload,
});

export const addOrEditMasterService = payload => ({
  type: masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE,
  payload,
});

export const addOrEditMasterServiceSuccess = payload => ({
  type: masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE_SUCCESS,
  payload,
});

export const addOrEditMasterServiceFail = payload => ({
  type: masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE_FAIL,
  payload,
});

export const resetAddOrEditMasterService = () => ({
  type: masterServicesActionTypes.RESET_ADD_OR_EDIT_MASTER_SERVICE,
});

export const deleteMasterService = payload => ({
  type: masterServicesActionTypes.DELETE_MASTER_SERVICE,
  payload,
});

export const deleteMasterServiceSuccess = payload => ({
  type: masterServicesActionTypes.DELETE_MASTER_SERVICE_SUCCESS,
  payload,
});

export const deleteMasterServiceFail = payload => ({
  type: masterServicesActionTypes.DELETE_MASTER_SERVICE_FAIL,
  payload,
});

export const resetDeleteMasterService = () => ({
  type: masterServicesActionTypes.RESET_DELETE_MASTER_SERVICE,
});

export const fetchCategories = () => ({
  type: masterServicesActionTypes.FETCH_CATEGORIES,
});

export const fetchCategoriesSuccess = payload => ({
  type: masterServicesActionTypes.FETCH_CATEGORIES_SUCCESS,
  payload,
});

export const fetchCategoriesFail = payload => ({
  type: masterServicesActionTypes.FETCH_CATEGORIES_FAIL,
  payload,
});
